export enum MyTaskFilter {
  ALL_TASKS,
  ASSIGNED_TO_ME,
  CREATED_BY_ME
}
